import * as Types from '../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Obt_SearchSurveyQueryVariables = Types.Exact<{
  criteria: Types.IObtSurveySearchCriteriaInput;
}>;


export type Obt_SearchSurveyQuery = { __typename?: 'Query', obtSearchSurvey?: { __typename?: 'ObtSurveyDetailsResponse', total?: number | null, surveyList?: Array<{ __typename?: 'ObtSurveyDetails', surveyId?: number | null, waveId?: string | null, partnerNo?: string | null, systemCode?: string | null, masterPartnerNo?: string | null, partnerName?: string | null, category?: string | null, companyCode?: string | null, countryCode?: string | null, otSurveyStatus?: string | null, surveyStatus?: string | null, surveyType?: string | null, surveyRequest?: string | null, masterDataAcceptedDate?: string | null, channelDataAcceptedDate?: string | null, agreementStatusDate?: string | null, provisionalGoLiveDate?: string | null, confirmedGoLiveDate?: string | null, surveySubmissionDate?: string | null, surveySentDate?: string | null, surveyStartDate?: string | null, surveySentToProvider?: boolean | null, dateSurveySentToProvider?: string | null, assignedPartnerUserId?: number | null, agreementDownloaded?: boolean | null, agreementStatusId?: number | null, agreementApproverName?: string | null, insertTime?: string | null, masterDataInsertTime?: string | null, updateTime?: string | null, technicalContactName?: string | null, technicalContactEmail?: string | null, technicalContactPhoneNumber?: string | null, connectivityInfoDate?: string | null, surveyActiveStatus?: boolean | null, agreementType?: string | null, assignedPartnerUserName?: string | null, remark?: string | null, partnerId?: string | null, apArPartnerLink?: string | null }> | null } | null };

export type Obt_SearchSurveyHistoryByCompanyCodePartnerNoQueryVariables = Types.Exact<{
  partnerNo: Types.Scalars['String']['input'];
  companyCode: Types.Scalars['String']['input'];
  category: Types.Scalars['String']['input'];
  systemCode: Types.Scalars['String']['input'];
}>;


export type Obt_SearchSurveyHistoryByCompanyCodePartnerNoQuery = { __typename?: 'Query', obtSearchSurveyHistoryByCompanyCodePartnerNo?: Array<{ __typename?: 'ObtSurveyDetails', surveyId?: number | null, waveId?: string | null, partnerNo?: string | null, systemCode?: string | null, masterPartnerNo?: string | null, partnerName?: string | null, category?: string | null, companyCode?: string | null, countryCode?: string | null, otSurveyStatus?: string | null, surveyStatus?: string | null, surveyType?: string | null, surveyRequest?: string | null, masterDataAcceptedDate?: string | null, channelDataAcceptedDate?: string | null, agreementStatusDate?: string | null, provisionalGoLiveDate?: string | null, confirmedGoLiveDate?: string | null, surveySubmissionDate?: string | null, surveySentDate?: string | null, surveySentToProvider?: boolean | null, dateSurveySentToProvider?: string | null, assignedPartnerUserId?: number | null, agreementDownloaded?: boolean | null, agreementStatusId?: number | null, agreementApproverName?: string | null, agreementApproverEmail?: string | null, agreementAcceptedDate?: string | null, insertTime?: string | null, updateTime?: string | null, technicalContactName?: string | null, technicalContactEmail?: string | null, technicalContactPhoneNumber?: string | null, connectivityInfoDate?: string | null, surveyActiveStatus?: boolean | null, agreementType?: string | null, assignedPartnerUserName?: string | null, cancelReason?: string | null, insertUser?: string | null, updateUser?: string | null }> | null };

export type Obt_SearchSurveyHistoryQueryVariables = Types.Exact<{
  surveyId: Types.Scalars['Float']['input'];
}>;


export type Obt_SearchSurveyHistoryQuery = { __typename?: 'Query', obtSearchSurveyHistory?: Array<{ __typename?: 'ObtSurveyDetails', surveyId?: number | null, waveId?: string | null, partnerNo?: string | null, systemCode?: string | null, masterPartnerNo?: string | null, partnerName?: string | null, category?: string | null, companyCode?: string | null, countryCode?: string | null, otSurveyStatus?: string | null, surveyStatus?: string | null, surveyType?: string | null, surveyRequest?: string | null, masterDataAcceptedDate?: string | null, channelDataAcceptedDate?: string | null, agreementStatusDate?: string | null, provisionalGoLiveDate?: string | null, confirmedGoLiveDate?: string | null, surveySubmissionDate?: string | null, surveySentDate?: string | null, surveySentToProvider?: boolean | null, dateSurveySentToProvider?: string | null, assignedPartnerUserId?: number | null, agreementDownloaded?: boolean | null, agreementStatusId?: number | null, agreementApproverName?: string | null, agreementApproverEmail?: string | null, insertTime?: string | null, updateTime?: string | null, technicalContactName?: string | null, technicalContactEmail?: string | null, technicalContactPhoneNumber?: string | null, connectivityInfoDate?: string | null, surveyActiveStatus?: boolean | null, agreementType?: string | null, assignedPartnerUserName?: string | null, cancelReason?: string | null, insertUser?: string | null, updateUser?: string | null }> | null };


export const Obt_SearchSurveyDocument = gql`
    query Obt_SearchSurvey($criteria: IObtSurveySearchCriteriaInput!) {
  obtSearchSurvey(criteria: $criteria) {
    surveyList {
      surveyId
      waveId
      partnerNo
      systemCode
      masterPartnerNo
      partnerName
      category
      companyCode
      countryCode
      otSurveyStatus
      surveyStatus
      surveyType
      surveyRequest
      masterDataAcceptedDate
      channelDataAcceptedDate
      agreementStatusDate
      provisionalGoLiveDate
      confirmedGoLiveDate
      surveySubmissionDate
      surveySentDate
      surveyStartDate
      surveySentToProvider
      dateSurveySentToProvider
      assignedPartnerUserId
      agreementDownloaded
      agreementStatusId
      agreementApproverName
      insertTime
      masterDataInsertTime
      updateTime
      technicalContactName
      technicalContactEmail
      technicalContactPhoneNumber
      connectivityInfoDate
      surveyActiveStatus
      agreementType
      assignedPartnerUserName
      remark
      partnerId
      apArPartnerLink
    }
    total
  }
}
    `;

/**
 * __useObt_SearchSurveyQuery__
 *
 * To run a query within a React component, call `useObt_SearchSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useObt_SearchSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObt_SearchSurveyQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useObt_SearchSurveyQuery(baseOptions: Apollo.QueryHookOptions<Obt_SearchSurveyQuery, Obt_SearchSurveyQueryVariables> & ({ variables: Obt_SearchSurveyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Obt_SearchSurveyQuery, Obt_SearchSurveyQueryVariables>(Obt_SearchSurveyDocument, options);
      }
export function useObt_SearchSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Obt_SearchSurveyQuery, Obt_SearchSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Obt_SearchSurveyQuery, Obt_SearchSurveyQueryVariables>(Obt_SearchSurveyDocument, options);
        }
// @ts-ignore
export function useObt_SearchSurveySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Obt_SearchSurveyQuery, Obt_SearchSurveyQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_SearchSurveyQuery, Obt_SearchSurveyQueryVariables>;
export function useObt_SearchSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_SearchSurveyQuery, Obt_SearchSurveyQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_SearchSurveyQuery | undefined, Obt_SearchSurveyQueryVariables>;
export function useObt_SearchSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_SearchSurveyQuery, Obt_SearchSurveyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Obt_SearchSurveyQuery, Obt_SearchSurveyQueryVariables>(Obt_SearchSurveyDocument, options);
        }
export type Obt_SearchSurveyQueryHookResult = ReturnType<typeof useObt_SearchSurveyQuery>;
export type Obt_SearchSurveyLazyQueryHookResult = ReturnType<typeof useObt_SearchSurveyLazyQuery>;
export type Obt_SearchSurveySuspenseQueryHookResult = ReturnType<typeof useObt_SearchSurveySuspenseQuery>;
export type Obt_SearchSurveyQueryResult = Apollo.QueryResult<Obt_SearchSurveyQuery, Obt_SearchSurveyQueryVariables>;
export const Obt_SearchSurveyHistoryByCompanyCodePartnerNoDocument = gql`
    query Obt_SearchSurveyHistoryByCompanyCodePartnerNo($partnerNo: String!, $companyCode: String!, $category: String!, $systemCode: String!) {
  obtSearchSurveyHistoryByCompanyCodePartnerNo(
    partnerNo: $partnerNo
    companyCode: $companyCode
    category: $category
    systemCode: $systemCode
  ) {
    surveyId
    waveId
    partnerNo
    systemCode
    masterPartnerNo
    partnerName
    category
    companyCode
    countryCode
    otSurveyStatus
    surveyStatus
    surveyType
    surveyRequest
    masterDataAcceptedDate
    channelDataAcceptedDate
    agreementStatusDate
    provisionalGoLiveDate
    confirmedGoLiveDate
    surveySubmissionDate
    surveySentDate
    surveySentToProvider
    dateSurveySentToProvider
    assignedPartnerUserId
    agreementDownloaded
    agreementStatusId
    agreementApproverName
    agreementApproverEmail
    agreementAcceptedDate
    insertTime
    updateTime
    technicalContactName
    technicalContactEmail
    technicalContactPhoneNumber
    connectivityInfoDate
    surveyActiveStatus
    agreementType
    assignedPartnerUserName
    cancelReason
    insertUser
    updateUser
  }
}
    `;

/**
 * __useObt_SearchSurveyHistoryByCompanyCodePartnerNoQuery__
 *
 * To run a query within a React component, call `useObt_SearchSurveyHistoryByCompanyCodePartnerNoQuery` and pass it any options that fit your needs.
 * When your component renders, `useObt_SearchSurveyHistoryByCompanyCodePartnerNoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObt_SearchSurveyHistoryByCompanyCodePartnerNoQuery({
 *   variables: {
 *      partnerNo: // value for 'partnerNo'
 *      companyCode: // value for 'companyCode'
 *      category: // value for 'category'
 *      systemCode: // value for 'systemCode'
 *   },
 * });
 */
export function useObt_SearchSurveyHistoryByCompanyCodePartnerNoQuery(baseOptions: Apollo.QueryHookOptions<Obt_SearchSurveyHistoryByCompanyCodePartnerNoQuery, Obt_SearchSurveyHistoryByCompanyCodePartnerNoQueryVariables> & ({ variables: Obt_SearchSurveyHistoryByCompanyCodePartnerNoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Obt_SearchSurveyHistoryByCompanyCodePartnerNoQuery, Obt_SearchSurveyHistoryByCompanyCodePartnerNoQueryVariables>(Obt_SearchSurveyHistoryByCompanyCodePartnerNoDocument, options);
      }
export function useObt_SearchSurveyHistoryByCompanyCodePartnerNoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Obt_SearchSurveyHistoryByCompanyCodePartnerNoQuery, Obt_SearchSurveyHistoryByCompanyCodePartnerNoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Obt_SearchSurveyHistoryByCompanyCodePartnerNoQuery, Obt_SearchSurveyHistoryByCompanyCodePartnerNoQueryVariables>(Obt_SearchSurveyHistoryByCompanyCodePartnerNoDocument, options);
        }
// @ts-ignore
export function useObt_SearchSurveyHistoryByCompanyCodePartnerNoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Obt_SearchSurveyHistoryByCompanyCodePartnerNoQuery, Obt_SearchSurveyHistoryByCompanyCodePartnerNoQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_SearchSurveyHistoryByCompanyCodePartnerNoQuery, Obt_SearchSurveyHistoryByCompanyCodePartnerNoQueryVariables>;
export function useObt_SearchSurveyHistoryByCompanyCodePartnerNoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_SearchSurveyHistoryByCompanyCodePartnerNoQuery, Obt_SearchSurveyHistoryByCompanyCodePartnerNoQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_SearchSurveyHistoryByCompanyCodePartnerNoQuery | undefined, Obt_SearchSurveyHistoryByCompanyCodePartnerNoQueryVariables>;
export function useObt_SearchSurveyHistoryByCompanyCodePartnerNoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_SearchSurveyHistoryByCompanyCodePartnerNoQuery, Obt_SearchSurveyHistoryByCompanyCodePartnerNoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Obt_SearchSurveyHistoryByCompanyCodePartnerNoQuery, Obt_SearchSurveyHistoryByCompanyCodePartnerNoQueryVariables>(Obt_SearchSurveyHistoryByCompanyCodePartnerNoDocument, options);
        }
export type Obt_SearchSurveyHistoryByCompanyCodePartnerNoQueryHookResult = ReturnType<typeof useObt_SearchSurveyHistoryByCompanyCodePartnerNoQuery>;
export type Obt_SearchSurveyHistoryByCompanyCodePartnerNoLazyQueryHookResult = ReturnType<typeof useObt_SearchSurveyHistoryByCompanyCodePartnerNoLazyQuery>;
export type Obt_SearchSurveyHistoryByCompanyCodePartnerNoSuspenseQueryHookResult = ReturnType<typeof useObt_SearchSurveyHistoryByCompanyCodePartnerNoSuspenseQuery>;
export type Obt_SearchSurveyHistoryByCompanyCodePartnerNoQueryResult = Apollo.QueryResult<Obt_SearchSurveyHistoryByCompanyCodePartnerNoQuery, Obt_SearchSurveyHistoryByCompanyCodePartnerNoQueryVariables>;
export const Obt_SearchSurveyHistoryDocument = gql`
    query Obt_SearchSurveyHistory($surveyId: Float!) {
  obtSearchSurveyHistory(surveyId: $surveyId) {
    surveyId
    waveId
    partnerNo
    systemCode
    masterPartnerNo
    partnerName
    category
    companyCode
    countryCode
    otSurveyStatus
    surveyStatus
    surveyType
    surveyRequest
    masterDataAcceptedDate
    channelDataAcceptedDate
    agreementStatusDate
    provisionalGoLiveDate
    confirmedGoLiveDate
    surveySubmissionDate
    surveySentDate
    surveySentToProvider
    dateSurveySentToProvider
    assignedPartnerUserId
    agreementDownloaded
    agreementStatusId
    agreementApproverName
    agreementApproverEmail
    insertTime
    updateTime
    technicalContactName
    technicalContactEmail
    technicalContactPhoneNumber
    connectivityInfoDate
    surveyActiveStatus
    agreementType
    assignedPartnerUserName
    cancelReason
    insertUser
    updateUser
  }
}
    `;

/**
 * __useObt_SearchSurveyHistoryQuery__
 *
 * To run a query within a React component, call `useObt_SearchSurveyHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useObt_SearchSurveyHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObt_SearchSurveyHistoryQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useObt_SearchSurveyHistoryQuery(baseOptions: Apollo.QueryHookOptions<Obt_SearchSurveyHistoryQuery, Obt_SearchSurveyHistoryQueryVariables> & ({ variables: Obt_SearchSurveyHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Obt_SearchSurveyHistoryQuery, Obt_SearchSurveyHistoryQueryVariables>(Obt_SearchSurveyHistoryDocument, options);
      }
export function useObt_SearchSurveyHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Obt_SearchSurveyHistoryQuery, Obt_SearchSurveyHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Obt_SearchSurveyHistoryQuery, Obt_SearchSurveyHistoryQueryVariables>(Obt_SearchSurveyHistoryDocument, options);
        }
// @ts-ignore
export function useObt_SearchSurveyHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Obt_SearchSurveyHistoryQuery, Obt_SearchSurveyHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_SearchSurveyHistoryQuery, Obt_SearchSurveyHistoryQueryVariables>;
export function useObt_SearchSurveyHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_SearchSurveyHistoryQuery, Obt_SearchSurveyHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<Obt_SearchSurveyHistoryQuery | undefined, Obt_SearchSurveyHistoryQueryVariables>;
export function useObt_SearchSurveyHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Obt_SearchSurveyHistoryQuery, Obt_SearchSurveyHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Obt_SearchSurveyHistoryQuery, Obt_SearchSurveyHistoryQueryVariables>(Obt_SearchSurveyHistoryDocument, options);
        }
export type Obt_SearchSurveyHistoryQueryHookResult = ReturnType<typeof useObt_SearchSurveyHistoryQuery>;
export type Obt_SearchSurveyHistoryLazyQueryHookResult = ReturnType<typeof useObt_SearchSurveyHistoryLazyQuery>;
export type Obt_SearchSurveyHistorySuspenseQueryHookResult = ReturnType<typeof useObt_SearchSurveyHistorySuspenseQuery>;
export type Obt_SearchSurveyHistoryQueryResult = Apollo.QueryResult<Obt_SearchSurveyHistoryQuery, Obt_SearchSurveyHistoryQueryVariables>;